<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Verwaltung"}}</h4>
	</div>
</div>

{{errors.miscinfo}}

<div class="row">
	<div class="col-xs-12 col-sm-6 p-10">
		<div id="h-address" class="card-box" style="min-height: 200px;">
			<div class="row">
				<div class="col-xs-10 col-lg-11">
					<h4 class="heading">{{ TR "Adresse" }}</h4>
				</div>
				<div class="col-xs-2 col-lg-1">
				{{#unless errors.address}}
					{{#IF_AVAILABLE_ANY 'addr_street' 'addr_number' 'addr_city' 'addr_code' 'addr_country'}}
					{{#if address}}
					{{#unless isReadOnly}}
					<button class="btn btn-white pull-right js-modal_management_edit" field-id="address">
						<i class="glyphicon glyphicon-pencil"></i>
					</button>
					{{/unless}}
					{{/if}}
					{{/IF_AVAILABLE_ANY}}
				{{/unless}}
				</div>
			</div>
			<div class="row m-t-10">
				<div class="col-sm-12 col-lg-12">
				<dl class="dl-horizontal m-b-0">
					{{#if errors.address}}
						<div class="alert alert-danger">
							{{TR errors.address}}
						</div>
					{{else}}
						{{#each address}}
							<dt>{{ TR @key }}</dt>
							<dd>{{ this }}</dd>
						{{else}}
							{{TR "Keine Adresse hinterlegt"}}
						{{/each}}
					{{/if}}
				</dl>
				</div>
			</div>
		</div>
	</div>
	<div class="col-xs-12 col-sm-6 p-10">
		<div id="h-partner" class="card-box" style="min-height: 200px;">
			<div class="row">
				<div class="col-xs-10 col-lg-11">
					<h4 class="heading">{{ TR "AnsprechpartnerIn" }}</h4>
				</div>
				<div class="col-xs-2 col-lg-1">
				{{#IF_AVAILABLE_ANY 'ctct_name' 'ctct_phone' 'ctct_email'}}
				{{#unless errors.contactperson}}
					{{#unless isReadOnly}}
					<button class="btn btn-white pull-right js-modal_management_edit" field-id="contactperson">
						<i class="glyphicon glyphicon-pencil"></i>
					</button>
					{{/unless}}
				{{/unless}}
				{{/IF_AVAILABLE_ANY}}
				</div>
			</div>
			<div class="row m-t-10">
				<div class="col-sm-12 col-lg-12">
				<dl class="dl-horizontal m-b-0">
					{{#if errors.contactperson}}
						<div class="alert alert-danger">
							{{TR errors.contactperson}}
						</div>
					{{else}}
						{{#each contactperson}}
							<dt>{{ TR @key }}</dt>
							<dd>{{ this }}</dd>
						{{else}}
							{{TR "Kein Ansprechpartner hinterlegt"}}
						{{/each}}
					{{/if}}
				</dl>
				</div>
			</div>
		</div>
	</div>
</div>
<div id="h-additional-info" class="card-box clearfix">
	<div class="row">
		<div class="col-xs-10 col-lg-11">
			<h4 class="heading">{{TR "Weitere Informationen"}}</h4>
		</div>
		<div class="col-xs-2 col-lg-1">
		{{#unless errors.miscinfo}}
			{{#if canEditMisc}}
			{{#if miscinfo}}
			{{#unless isReadOnly}}
			<button class="btn btn-white pull-right js-modal_management_edit" field-id="miscinfo">
				<i class="glyphicon glyphicon-pencil"></i>
			</button>
			{{/unless}}
			{{/if}}
			{{/if}}
		{{/unless}}
		</div>
	</div>
	<div class="row m-t-10">
		<div class="col-xs-10 col-lg-11">
		<dl class="dl-horizontal wide m-b-0">
			{{#if errors.miscinfo}}
				<div class="alert alert-danger">
					{{TR errors.miscinfo}}
				</div>
			{{else}}
				{{#each miscinfo.fields}}
					<dt>{{this.name}}</dt>
					<dd>
						{{#if this.isTextArea}}<pre class="text-area">{{/if}}
{{this.value}}
						{{#if this.isTextArea}}</pre>{{/if}}
					</dd>
				{{else}}
					{{TR "Keine Informationen hinterlegt"}}
				{{/each}}
			{{/if}}
		</dl>
		</div>
	</div>
</div>
